
var token = ((document.getElementById("apply_discount") || {}).dataset || {}).hash



let balanceObj = {}
class SubscriptionItemManagerDiscount {
	constructor(opts) {

		this.shop = opts.shop;
		this.customerId = opts.customerId;
		this.customerEmail = opts.email;
		this.subscriptionId = opts.subscriptionId;
		this.maxAge = opts.maxAge || 60 * 1000;
		this.discounted_price = 6.95;
		this.subscriptionCache = { data: null, age: null };
	}
	storeSubscription(subscription) { // possible better solution?
		// TODO: add check if it's a real subscription;
		const store = (subscription) => {
			if (subscription) this.subscriptionCache = { data: subscription, age: new Date() };
			return subscription;
		}
		if (subscription.then) return subscription.then(store); // await for response
		else return store(subscription);
	}
	async getSubscription(force = false, store = true) {
		if (!force && this.subscriptionCache.data && this.subscriptionCache.age && Date.now() - this.subscriptionCache.age < this.maxAge) {
			return this.subscriptionCache.data;
		}
		else {
			const subscription = await this.fetchSubscription(this.subscriptionId);
			if (store) this.storeSubscription(subscription);
			return subscription;
		};
	}
	getLineItems() {
		return this.getSubscription(...arguments)
			.then((res) => this.constructor._mapLineItems(res));
	}
	// APPSTLE REMOVED: Static fetch method disabled - called defunct Appstle proxy
	// static fetch(path, ...args) {
	// 	return fetch(new URL(path, 'https://inspiredgo.ca/apps/appstleProxy/'), ...args).then(res => {
	// 		if (!res.ok) throw res;
	// 		return res;
	// 	}); // force error if not ok
	// }
	fetch() {
		return this.constructor.fetch(...arguments);
	}
	fetchSubscription(id) {
		var x = (id || this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.constructor.fetch(`external/v2/subscription-contracts/contract-external/${id || this.subscriptionId}?shop=${this.shop}&email=${this.customerEmail}&hash=${hash}`)
			.then(res => res.json());
	}
	static _mapLineItems(subscriptionContract) {
		const mapped = (((subscriptionContract || {}).lines || {}).edges || []).map((edge) => {
			const node = edge.node;
			return {
				id: this._extractGid(node.id),
				variantId: this._extractGid(node.variantId),
				price: node?.currentPrice?.amount,
				discountedPrice: node?.lineDiscountedPrice?.amount ? (node?.lineDiscountedPrice?.amount / node?.quantity) : node?.currentPrice?.amount,
				quantity: node.quantity,
				title: node.title,
				image: node.variantImage.transformedSrc,
			}
		})
		return mapped
	}
	static _extractGid(gid) {
		if (!gid) return;
		const lastSlash = gid.lastIndexOf('/');
		if (!lastSlash) return;
		return gid.slice(lastSlash + 1);
	}
	static _getVariantLineItems(lineItems, id) {
		return lineItems.filter(line => line.variantId === id);
	}
	getValidSubscriptions() {
		var x = this.customerId;
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();

		return this.constructor.fetch(`external/v2/subscription-customers/valid/${this.customerId}?shop=${this.shop}&email=${this.customerEmail}&hash=${hash}`)
			.then(res => res.json());
	}
	findActiveSubscription() {
		const subscriptions = [];
		return this.getValidSubscriptions()
			.then(async (res) => {
				if (!(res || []).length) return;
				for (let subscriptionId of res) {
					const subscription = await this.fetchSubscription(subscriptionId);
					if (subscription.status === 'ACTIVE') return this.storeSubscription(subscription);
					subscriptions.push(subscription);
				}
				return this.storeSubscription(subscriptions.find(subscription => subscription.status === 'PAUSED'));
			});
	}
	updateDeliveryPrice(contract_id, res) {
		var total_price = this.constructor._mapLineItems(res).reduce((total, item) => {
			return total + (item.price * item.quantity);
		}, 0);
		if (window.subscription_price) {
			if ((window.subscription_price >= 61 && total_price <= 61) || (window.subscription_price <= 61 && total_price >= 61)) {
				this._updateDeliveryPrice(total_price, contract_id);
			}
		} else {

			this._updateDeliveryPrice(total_price, contract_id);
		}

	}


	_updateDeliveryPrice(total_price, contract_id) {
		var discount_price = 0;
		window.subscription_price = total_price;
		if (total_price < 61)
			discount_price = this.discounted_price;


		var x = contract_id.toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		this.fetch(`external/v2/subscription-contracts-update-delivery-price?contractId=${contract_id}&deliveryPrice=${discount_price}&hash=${hash}&email=${this.customerEmail}`, {
			method: 'PUT'
		}).catch(error => { })

	}

	apply_discount_code(id, discount_code) {
		var x = (id).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`external/v2/subscription-contracts-apply-discount?contractId=${id}&discountCode=${discount_code}&hash=${hash}&email=${this.customerEmail}&shop=${this.shop}`, { method: 'PUT' })
			.then(res => res.json())
	}

	/*
	  These functions actually update the cart. 
	  The functions without an underscore prefix are for?
	*/
	_addProduct(id, quantity, price) {
		this.lockQuantityInputs(id)

		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`external/v2/subscription-contracts-add-line-item?contractId=${this.subscriptionId}&quantity=${quantity}&hash=${hash}&email=${this.customerEmail}&shop=${this.shop}&variantId=gid%3A%2F%2Fshopify%2FProductVariant%2F${id}`, { method: 'PUT' })
			.then(res => res.json()).then(res => {
				this.updateDeliveryPrice(this.subscriptionId, res);
				return res;
			})
			.finally(() => {
				this.unlockQuantityInputs(id)
			})
	}




	_deleteProduct(lineId, id) {
		this.lockQuantityInputs(id);
		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`external/v2/subscription-contracts-remove-line-item?contractId=${this.subscriptionId}&hash=${hash}&email=${this.customerEmail}&lineId=${encodeURIComponent('gid://shopify/SubscriptionLine/' + lineId)}&shop=${this.shop}`, { method: 'PUT' })
			.then(res => res.json()).then(res => {
				this.updateDeliveryPrice(this.subscriptionId, res);
				return res;
			})
			.finally(() => {
				this.unlockQuantityInputs(id)
			})
	}
	_updateProduct(lineId, id, quantity) {
		this.lockQuantityInputs(id)
		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`external/v2/subscription-contracts-update-line-item-quantity?contractId=${this.subscriptionId}&hash=${hash}&email=${this.customerEmail}&lineId=${encodeURIComponent('gid://shopify/SubscriptionLine/' + lineId)}&quantity=${quantity}&variantId=${encodeURIComponent('gid://shopify/ProductVariant/' + id)}`, {
			method: 'PUT'
		})
			.then(res => res.json()).then(res => {
				this.updateDeliveryPrice(this.subscriptionId, res);
				return res;
			})
			// Re-enable the button after the fetch has returned. This is to solve for a bug causing inaccurate quantities
			.finally(() => {
				this.unlockQuantityInputs(id)
			})
	}

	/*
			Updating product while an exsiting request is in progress
			causes the card to update with an incorrect quantity.
			Lock the inputs for that product while a request is in progress.
	*/
	lockQuantityInputs(id) {
		const inputId = `#QuantityInput-${id}`
		const menuInputId = `#MenuQuantityInput-${id}`
		const node = document.querySelector(inputId)?.querySelector('input')
		const menuNode = document.querySelector(menuInputId)?.querySelector('input')
		const lockEvent = new CustomEvent('lockQuantity', { bubbles: true, detail: { variantId: id } })
		if (node) node.dispatchEvent(lockEvent)
		if (menuNode) menuNode.dispatchEvent(lockEvent)
	}

	unlockQuantityInputs(id) {
		const inputId = `#QuantityInput-${id}`
		const menuInputId = `#MenuQuantityInput-${id}`
		const node = document.querySelector(inputId)?.querySelector('input')
		const menuNode = document.querySelector(menuInputId)?.querySelector('input')
		const unlockEvent = new CustomEvent('unlockQuantity', { bubbles: true, detail: { variantId: id } })
		if (node) node.dispatchEvent(unlockEvent)
		if (menuNode) menuNode.dispatchEvent(unlockEvent)
	}


	/*
	  What does this do specifically? Why are some async and some not?
	  Write comments as to why these functions exist and what purpose they serve :)
	*/
	deleteProduct(id, variantLineItems) {
		return this.storeSubscription(this._deleteProduct(variantLineItems[0].id, id))
			.then(subscription => {
				const lineItems = this.constructor._mapLineItems(subscription);

				variantLineItems = this.constructor._getVariantLineItems(lineItems, id);
				return variantLineItems.length ? this.deleteProduct(id, variantLineItems) : subscription;
			}).catch(() => {
				document.querySelector(".drawer-btn").classList.remove("skipLoading");
				document.querySelector(".ldSpan").classList.remove("skipLoading");
			})
	}
	/*
		variantLineItems is an array of items with the same variant Ids
		if the array length > 1 there are duplicates.
		Method removes variantLineItems[0] using its UID, 
		This returns an updated subscription contract, then it uses recursion to update the quantity of the remaining line item.
		The line in the "then" function of the _deleteProduct call was parsing the line items for variants a second time but since the original variant had already been removed
		this lead to the remaining item not having its quantity updated. We only need to re-parse if the original variantLineItems array is > 2.
	*/
	updateProduct(id, quantity, price, variantLineItems = []) {
		if (variantLineItems.length > 1) {
			return this.storeSubscription(this._deleteProduct(variantLineItems[0].id, id))
				.then(subscription => {
					// TODO - this could be cleaner. re-write this recursion to be easier to read.
					if (variantLineItems.length > 2)
						variantLineItems = this.constructor._getVariantLineItems(this.constructor._mapLineItems(subscription), id)
					else variantLineItems = [variantLineItems[1]]

					return this.updateProduct(id, quantity, price, variantLineItems);
				});
		}
		else {
			if (variantLineItems.length <= 0) return;
			return this._updateProduct(variantLineItems[0].id, id, quantity, price);  //remove *quantity
		}
	}

	async updateQuantity(id, quantity, price) {
		const lineItems = await this.getLineItems(false, true);
		const variantLineItems = this.constructor._getVariantLineItems(lineItems, id);
		// add item
		if (variantLineItems.length === 0) {
			// If no items, no changes need, otherwise add the item.
			if (quantity <= 0) return;
			return this.storeSubscription(this._addProduct(id, quantity, price)); //removed *quantity
		}
		else if (variantLineItems.length >= 1) {
			// If quantity is <= 0, remove the item. Otherwise, update the quanity/press
			if (quantity <= 0) return this.deleteProduct(id, variantLineItems);
			return await this.updateProduct(id, quantity, price, variantLineItems);
		}
	}
}


class ApplyDiscount extends HTMLElement {
	constructor() {
		super();
		this.previousValue = 0;
		// APPSTLE REMOVED: Appstle proxy URL disabled
		// this.base_url = "https://inspiredgo.ca/apps/appstleProxy/";
		// this.api_key = "91c37c6948166a13b2a1308962f8fef8";
		this.customer_email = window.customer.email;
		this.button = this.querySelector('button')
		this.loadingMessage = document.querySelector('.credit_available_message');
		this.button.style = "display:none";
		this.button.disabled = true;
		this.subscriptionItemManager = new SubscriptionItemManagerDiscount({ shop: window.shop, customerId: window.customer.id, email: window.customer.email });
		this.storeBalance = 0;
		const tagsTemplate = document.getElementById('template-tags-list');
		// this.tagsList = tagsTemplate.cloneNode(true);
	
		this.set_active_subscription()

		// else {
		this.button.addEventListener("click", async (e) => {
			this.button.innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';
			try {
				var already_discount = ((this.active_subscription || {}).discounts || {}).edges || []
				var id = this.subscriptionItemManager.constructor._extractGid(this.active_subscription.id)

				if (already_discount.length > 0) {
					for (var i = 0; i < already_discount.length; i++) {

						await this.remove_discount(already_discount[i].node.id, id)
					}
				}
				var x = await this.get_discount_code();
				this.active_subscription = await this.apply_discount_code(x.discount_code);
				this.set_tags(this.active_subscription)
				this.querySelector("#success_message").innerHTML = "Store credit of $" + this.storeBalance + " has been applied successfully to your upcoming subscription order."
			}
			catch (error) {
				this.querySelector("#error_message").innerHTML = "Error applying store credit";
			}
			this.button.innerHTML = "Store Credit Applied";

		})
	}
	set_tags(subscription){
		// var discounts = (subscription.discounts || {}).edges || [];
		// document.getElementById("discount-code-success").innerHTML =""
		// document.getElementById("discount-code-error").innerHTML =""
		// document.getElementById("error_message").innerHTML =""
		// document.getElementById("success_message").innerHTML =""
		
		// var tag_node = this.tagsList.content.querySelector(".tags-list").cloneNode(true);
		// tag_node.innerHTML=""
		// var tag = '';
		// for(var i =0;i<discounts.length;i++){
		// 	tag = this.tagsList.content.querySelector(".tag").cloneNode(true);
		// 	tag.querySelector(".reduction-code__text").innerHTML = discounts[i].node.title;
		// 	tag.querySelector(".tag__button").addEventListener("click",(e)=>{
		// 		e.target.closest('.tag').style = "display:none";
		// 	})
		// 	tag_node.appendChild(tag);
		// }
		// document.querySelector("discount-tags").innerHTML = "";
		// document.querySelector("discount-tags").appendChild(tag_node);
	}
	async remove_discount(discount_id, subscribtion_id) {
		var x = (subscribtion_id).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await fetch(`${this.base_url}external/v2/subscription-contracts-remove-discount?hash=${hash}&email=${this.customer_email}&contractId=${subscribtion_id}&discountId=${discount_id}`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}

			})
	}
	async set_active_subscription() {
		try {
			this.active_subscription = await this.subscriptionItemManager.findActiveSubscription()
		} catch (error) {

		}
		var balance = 0
		try {
			var customer = await this.get_customer_credit()


			balance = customer.balance;

		}
		catch (error) {

		}
		// this.active_subscription = await subscription;
		var discounts = (this.active_subscription.discounts || {}).edges || [];
		var discounted_balance = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit"))
					discounted_balance += parseInt(discounts[i].node.value.amount.amount);
			} catch (error) {

			}
		}
		balance = balance - discounted_balance;
		if (balance > 0) {
			this.storeBalance = balance;
			this.button.style = "display:block"
			// this.button.style = "margin:0"
			this.loadingMessage.innerHTML = "You have $" + this.storeBalance + " in store credit available"
			this.button.disabled = false;


		} else {
			this.loadingMessage.innerHTML = "No store credit available"
		}

	}

	get_customer_credit() {
		var x = (token + '').replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return fetch(`${this.base_url}customers/get?hash=${hash}&email=${this.customer_email}`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ "customer_email": this.customer_email })
			}

		).then(res => res.json())
	}
	get_discount_code() {
		var x = (token + '').replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return fetch(`${this.base_url}credits/checkout?hash=${hash}&email=${this.customer_email}`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ "customer_email": this.customer_email })
			}

		).then(res => res.json())
	}

	get_active_subscription() {
		return this.active_subscription;
	}
	apply_discount_code(discount_code) {
		var id = this.subscriptionItemManager.constructor._extractGid(this.active_subscription.id)
		return this.subscriptionItemManager.apply_discount_code(id, discount_code)


	}
}


customElements.define('apply-discount', ApplyDiscount);